import styled from 'styled-components';
import { ButtonOptions } from '../../../../components/ButtonOptions';
import { SeparateLabel } from '../../../../components/SeparateLabel';
import { TextInfo } from '../../../../components/TextInfo';
import { colors, radius } from '../../../../styles/tokens';

export const Container = styled.div`
  padding: 40px;
  min-height: 100vh;

  @media (max-width: 1199px) {
    padding: 20px;
  }
`;

export const PageHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;

  @media (max-width: 1199px) {
    flex-direction: column;
  }
`;

export const PageTitle = styled.h1`
  font-size: 32px;
  font-weight: 800;
  color: ${colors.onSurface};
  letter-spacing: -0.01em;
`;

export const WarningsContainer = styled.div`
  margin: 32px 0;

  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
`;

export const Info = styled(TextInfo)`
  align-items: flex-start;

  padding: 16px;
  border-radius: ${radius.md};
  border: 1px solid ${colors.outlineVariant}40;
  background-color: ${colors.surfaceContainerLow};

  span {
    text-align: left;
    line-height: 1.5;
  }
`;

export const HistoryPaymentsContainer = styled.div`
  width: 100%;
`;

export const Separate = styled(SeparateLabel)`
  margin-bottom: 16px;
`;

export const Button = styled(ButtonOptions)``;

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const StatusPaid = styled.span`
  display: inline-flex;
  padding: 4px 12px;
  border-radius: ${radius.full};

  background-color: #32a54a1a;
  color: #32a54a;

  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const StatusPending = styled.span`
  display: inline-flex;
  padding: 4px 12px;
  border-radius: ${radius.full};

  background-color: ${colors.primary}1a;
  color: ${colors.primary};
  border: 1px solid ${colors.primary}40;

  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const StatusCancelled = styled.span`
  display: inline-flex;
  padding: 4px 12px;
  border-radius: ${radius.full};

  background-color: ${colors.surfaceContainerHighest};
  color: ${colors.onSurfaceVariant};

  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
`;

export const ActionLink = styled.button`
  background: transparent;
  border: none;
  padding: 0;

  color: ${colors.primary};
  text-decoration: underline;

  font-size: 13px;
  font-weight: 700;

  cursor: pointer;
`;

export const ActionPlaceholder = styled.span`
  color: ${colors.onSurfaceVariant};
`;
